import {Module, Component} from 'app/decorators';
import R from 'app/resource';
import customerCardTpl from './customer.card.component.html';


@Module({
    name: "app.orders.compontents.customerCard",
    modules: [R],
})
@Component({
    selector: 'blnd-customer-card',
    template: customerCardTpl,
    bindings: {
        ngModel: '=',
        primary: '=',
        index: '=',
        type: '@',
    },
})
export default class CustomerCardComponent { }



// WEBPACK FOOTER //
// ./src/app/directives/billing/customer.card.component.js